'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import {Label, DropdownButton, MenuItem} from 'react-bootstrap';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZendeskCamera = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ZendeskCamera, _Component);

  function ZendeskCamera() {
    (0, _classCallCheck3.default)(this, ZendeskCamera);
    return (0, _possibleConstructorReturn3.default)(this, (ZendeskCamera.__proto__ || (0, _getPrototypeOf2.default)(ZendeskCamera)).apply(this, arguments));
  }

  (0, _createClass3.default)(ZendeskCamera, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.onUpdate) {
        this.props.onUpdate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.Camera, this.props);
    }
  }]);
  return ZendeskCamera;
}(_react.Component), _class.propTypes = {
  onUpdate: _react.PropTypes.func
}, _temp);
exports.default = ZendeskCamera;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ZendeskCamera/ZendeskCamera.js
 ** module id = 1389
 ** module chunks = 0
 **/